import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import useSendbirdApi from '@/hooks/useSendbirdApi';
import useAuthStore from '@/stores/authStore';

const ConnectInjector = () => {
  const { userInfo } = useAuthStore();
  const { sendbirdChat, connect, disconnect } = useSendbirdApi();
  const navigate = useNavigate();

  useEffect(() => {
    if (!userInfo || !sendbirdChat) {
      return;
    }

    const initSendbirdUserInfo = async () => {
      await connect?.(userInfo.userId);
      await sendbirdChat.updateCurrentUserInfo({
        profileUrl: `${import.meta.env.VITE_APP_API_URL}${userInfo?.userRegImg}` || '',
        nickname: userInfo.userName,
      });

      // 진입 시 전달된 쿼리 파라미터(open=setting-modal 등)가 유실되지 않도록 현재 search를 유지한다.
      navigate(
        { pathname: '/chat', search: window.location.search },
        {
          replace: true,
        },
      );
    };

    initSendbirdUserInfo();

    return () => {
      disconnect?.();
    };
  }, [userInfo, sendbirdChat, disconnect, navigate]);

  return <></>;
};

export default ConnectInjector;
